import React, {useContext, useEffect, useState, useRef, useCallback} from 'react';
import {
    Button,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    TextField
} from '@mui/material';
import ReactQuill from 'react-quill'
import {useParams} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {SectionService, StatementService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import {NotificationContext} from "../../../components/NotificationContext";
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import { useHistory } from 'react-router-dom';
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';
import Link from '@mui/material/Link';

const StatementForm = () => {
        const methods = useForm();
        const history = useHistory();
        const {showMessage} = useContext(NotificationContext);
        const [data, setData] = useState({content: '', statementChildren: []});
        const [tempData, setTempData] = useState({content: '', statementChildren: []});
        const [sections, setSections] = useState([]);
        const [open, setOpen] = useState(false);
        const [openConfirmation, setOpenConfirmation] = useState(false);
        const [openInfo, setOpenInfo] = useState(false);
        const [isReady, setIsReady] = useState(false);
        const [statements, setStatements] = useState([]);
        const [siStatement, setSiStatement] = useState([]);
        const [parentStatement, setParentStatement] = useState([]);
        const [content, setContent] = useState('');
       // const [tempContent, setTempContent] = useState('')
        const [block, setBlock] = useState(false);  
        const refSubmitButtom = useRef();
       // const historyDetail = history.action;
        const [pressed, setPressed] = useState(false)
        const {rights} = useContext(CurrentUserContext);
        const [showProgress, setShowProgress] = useState(false);
        const handleGoToIntendedPage = useCallback(
            (location) => history.push(location),
            [history]
          );

        const [triggerExit, setTriggerExit] = useState({
            onOk: false,
            path: ""
          });

       const [isVisibleDialog, setVisibleDialog] = useState(false);
        const {id} = useParams();

        const handleClose = () => {
            setOpen(false);
            setOpenConfirmation(false);
            setOpenInfo(false);
        }

        const removeChild = (child) => {
            setBlock(true);
            let newData = {...data};
            newData.statementChildren = data.statementChildren.filter((s) => child.childStatementId !== s.childStatementId);
            setData(newData);
        }

        const refreshStatements = (sectionId) => {
            StatementService
                .getAvailableStatementsFor(sectionId, data.id)
                .then((response) => {
                    setStatements(response.data);
                });
        }

        const removeStatement = () => {
            setShowProgress(true);
            StatementService.delete(data.id).then((response) => {                
                    showMessage('Successfully Deleted');
                    history.push("/templates/statements");   
                    setShowProgress(false);                                
                }).catch((response) => {                                       
                handleClose();               
                setOpenInfo(true);
                setShowProgress(false); 
                const responseStatement = response.response.data.statement;
                const responseSi = response.response.data.shippingInstructionStatement;
                const uniqueStatements = responseStatement.reduce((acc, current) => {
                    const x = acc.find(item => item.id === current.id);
                    if (!x) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                const uniqueSi = responseSi.reduce((acc, current) => {
                    const x = acc.find(item => item.id === current.id);
                    if (!x) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                uniqueSi.length > 0 ? setSiStatement(uniqueSi) : setSiStatement([]);
                uniqueStatements.length > 0 ? setParentStatement(uniqueStatements) : setParentStatement([]);                                  
                
            });
        }

        const addStatement = (statement) => {
            setBlock(true);
            let newData = {...data};
            newData.statementChildren.push({
                statementId: data.id,
                childStatementId: statement.id,
                statementOrder: 1,
                childStatement: statement
            });
            setData(newData);
            setTempData(tempData);
            setOpen(false);
        }

        useEffect(() => {
            if(data.sectionId !== tempData.sectionId){
                setBlock(true)
            }        
            if (data.sectionId !== undefined) {
                refreshStatements(data.sectionId);
            }   
          }, [data])

        useEffect(() => {
            SectionService.getAll().then((response) => {
                const statementSections = response.data.filter(s => s.allowStatements);
                setSections(statementSections);
            });
            StatementService.getById(id).then((response) => {
                    setTempData(response.data);  
                    setData(response.data);                                      
                    setContent(response.data.content);
                  //  setTempContent(response.data.content);
                    setIsReady(true);
                });            
        }, [id]);
  
       
        const triggerSubmit = () => {
            refSubmitButtom?.current?.click();
          };     
       
          const onSave = (event) => {
              triggerSubmit();
              setBlock(false);
              setVisibleDialog(false);
          }
      
          const checkModified = (event) => {
              if(event.type ===  "change"){
                  setBlock(true);
                     }
              if(data.content !== content){
                  setBlock(true);
              }
                  }

                  useEffect(() => {
                    window.onpopstate = e => {
                        setPressed(true)
                    };
                  });

          useEffect(() => {   
           //handle block navigate if form is dirty
          if(pressed){
            history.goBack();
          }
            const unblock = history.block((location) => {
              if (location.pathname !== `/templates/statements/${id}`) {
                if(block){
                    setVisibleDialog(true);   
                    setTriggerExit({...triggerExit, path: location.pathname});
                }
                else
                    {
                    setVisibleDialog(false);   
                    setTriggerExit({onOk: true, path: location.pathname});
                }                                         
                  }             
              if (triggerExit.onOk) {
                return true;
              }
              return false;
            });
            if(pressed){
                unblock();
               }
            if (triggerExit.onOk) {
                setBlock(false)
                handleGoToIntendedPage(triggerExit.path);               
              }
            return () => {
              unblock();             
            };        
          }, [pressed, history, triggerExit.onOk, triggerExit.path, block]);

        const {handleSubmit, control, errors} = methods;

        const handleNavigation = () => {
          history.push('/templates/statements/new')            
        }

        const onSubmit = d => {                             
            setBlock(false);
            setVisibleDialog(false); 
            setPressed(false); 
            // setTempContent(content);
           
            let newContent = (content === '<p><br></p>')? '' : content;
                setIsReady(false);               
                    StatementService.update({...data, ...d, content: newContent}).then((response) => {
                        showMessage('Statement updated.', 'success');
                    }).catch((err) => {
                        showMessage(err.message, 'error');
                    });                
                setTimeout(() => {
                    setIsReady(true);
                    history.push('/templates/statements')                    
                }, 100)                
                    };

        if (!isReady) {
            return (
                <CircularProgress/>
            );
        }
        return (
            <Container>
                <header>
                    <h1>Statement</h1>
                </header>              
                <Grid item xs={12}>
                                <Button variant='contained' color='primary' onClick={handleNavigation}>Create New</Button>
                            </Grid>                           
                <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
                <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Controller
                                name="title"
                                control={control}
                                as={TextField}
                                fullWidth
                                label="Title"
                                rules={{required: 'Title is required.'}}
                                color="primary"
                                variant="standard"
                                key={data.title}
                                defaultValue={data.title}
                                onChange={() => setData({...data, title: data.title})}
                            />
                         
                            <ValidationError error={errors.title}/>
                        </Grid>
                        <Grid item xs={8}>
                            <br/>
                            <div className="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth">
                                <label
                                    className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled"
                                    data-shrink="true">Content</label>
                            </div>
                            <FormControl label="Content" variant="outlined">

                                <ReactQuill value={content}
                                    onChange={setContent} />

                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <FormControlLabel label="Section"
                                              htmlFor="sectionId"
                                              className={'MuiInputLabel-shrink MuiFormLabel-filled'}
                                              labelPlacement="top"
                                              control={<></>}/>
                                              
                            <Controller
                                control={control}
                                name="sectionId"
                                rules={{required: 'Section is required.'}}
                                defaultValue={data.sectionId}
                                key={data.sectionId}
                                render={({value, onChange}) =>
                                    <Select
                                        value={sections.filter(s => s.id === value).map(v => {
                                            return {value: v.id, label: v.title}
                                        })}
                                        onChange={value => {
                                            onChange(value.value);
                                            setData({...data, sectionId: value.value})
                                        }}
                                        options={sections.map(p => ({value: p.id, label: p.title}))}
                                    />
                                }
                            />
                            <ValidationError error={errors.sectionId}/>
                        </Grid>
                        <Grid item xs={12}>
                            <b>Children</b>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" type="button"
                                disabled={!data.sectionId}    onClick={() => setOpen(true)}>Add</Button>
                            <hr/>

                            <table>
                                {data.statementChildren.filter(c => c.childStatement.allContent !== '').map((c) => {
                                    return <tr>
                                        <td>*</td>
                                        <td>
                                            <span dangerouslySetInnerHTML={{__html: c.childStatement.allContent}}></span>
                                        </td>
                                        <td>
                                            <IconButton size="small" aria-label="delete" onClick={() => removeChild(c)}>
                                                <DeleteIcon color="error"/>
                                            </IconButton>
                                        </td>
                                    </tr>
                                })}
                            </table>

                            {data.statementChildren.length === 0 && <>No Child Statements set under this.</>}

                            <hr/>
                        </Grid>
                        <Grid item xs={10}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {rights.includes("ROLE_SI_ADMIN") &&
                        <Grid item xs={2}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove statement</Button>
                        </Grid>
                      }
                    </Grid>
                    <button hidden={true} ref={refSubmitButtom} type={"submit"} />
                </form>
                <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this statement?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeStatement} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogTitle>                       
                          This statement can not be deleted because it is already in use in the following places.                                             
                    </DialogTitle>
                    <DialogTitle>
                    {siStatement.length > 0 &&
                      <div>
                       Shipping Instructions
                       </div>
                    }    
                  </DialogTitle>
                    {siStatement.map((s) => {
                       
                    return  <DialogContentText style={{padding: "0 24px"}}>  <Link                       
                        component="button"
                        variant="body2"
                        onClick={() => {
                            history.push(`/shipping-instruction/${s.id}`);
                            setOpenInfo(false);
                        }}
                      >
                       {s.grantCode} 
                      </Link>      
                      </DialogContentText >       
                    }
                )}
                   {parentStatement.length > 0 &&
                       <DialogTitle>
                       Statements
                       </DialogTitle>
                    }
                        {parentStatement.map((s) => {
                    return    <DialogContentText style={{padding: "0 24px"}}> <Link
                        component="button"
                        variant="body2"
                        onClick={() => {
                            history.push(`/templates/statement/${s.id}`);
                            setOpenInfo(false);
                        }}
                      >
                       {s.title} 
                      </Link>   
                      </DialogContentText >          
                    }
                )}
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add statement</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please add the statement here.
                        </DialogContentText>
                        <table>
                            <thead>
                            <tr>
                                <th></th>
                                <th>Title</th>
                            </tr>
                            </thead>
                            <tbody>
                            {statements.map((s) => {
                                return <tr id={s.id}>
                                    <td><Button variant="contained"
                                                color="primary"
                                                type="button"
                                                onClick={() => addStatement(s)}>Add</Button></td>
                                    <td>{s.title}</td>

                                </tr>
                            })}

                            </tbody>
                        </table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        );
    }
;

export default StatementForm;
